angular.module('bmsApp.employee').controller('EmployeeAdditionalPaymentModalCtrl', function ($scope,
																							 $modalInstance,
																							 $ngBootbox,
																							 ConfigService,
																							 EmployeeAdditionalPaymentSvc,
																							 additionalPayment) {

	var config = ConfigService.config;
	config.datePicker.basic.options.parentEl = '.modal-content';

	$scope.EmployeeAdditionalPaymentModalCtrl = {
		loading: false,
		processing: false,
		submitted: false,
		config: config,
		methods: {
			init: function () {
				$scope.EmployeeAdditionalPaymentModalCtrl.additionalPayment = angular.extend({
					date: moment().format('YYYY-MM-DD'),
					amount: 0,
					description: ''
				}, angular.copy(additionalPayment));
			},
			cancel: function () {
				$ngBootbox.confirm('Are you sure you want to do this?')
					.then(function () {
						$modalInstance.dismiss('cancel');
					});
			},
			submit: function () {
				var modalResult = {};
				EmployeeAdditionalPaymentSvc.save($scope.EmployeeAdditionalPaymentModalCtrl.additionalPayment)
					.then(function (response) {
						modalResult.success = response.data.success;
						$modalInstance.close(modalResult);
					});
			}
		},
		formvalidatorconfig: {
			submitHandler: function () {
				$scope.EmployeeAdditionalPaymentModalCtrl.methods.submit();
			},
			errorPlacement: function (error) {
				error.appendTo('#employee-additional-payments-errors');
			},
			errorContainer: '#employee-additional-payments-errors'
		}
	};

	$scope.EmployeeAdditionalPaymentModalCtrl.methods.init();

});
